import "../css/footer.css";
import ig from "../image/ig.png";
import yt from "../image/yt.png";

export default function Footer() {
  return (
    <footer>
      <div className="container d-flex">
        <div className="footer-box">
          <p>Find a Store</p>
          <p>Become a Member</p>
          <p>Sign Up for Email</p>
          <p>Student Discount</p>
          <p>Send Us Feedback</p>
        </div>
        <div className="footer-box">
          <p>Get Help</p>
          <a>Order Status</a>
          <a>Delivery</a>
          <a>Returns</a>
          <a>Payment Options</a>
          <a>Contact Us</a>
        </div>
        <div className="footer-box">
          <p>About Nike</p>
          <a>News</a>
          <a>Carrers</a>
          <a>Investors</a>
          <a>Sustainability</a>
        </div>
        <div className="footer-box social-box">
          <div className="social-media">
            <div>
              <img src={yt} />
            </div>
            <div>
              <img src={ig} />
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="copyright">
          © 2022 Nike, Inc. All Rights Reserved
        </div>
      </div>
    </footer>
  )
}